import videojs from 'video.js';
import Player from 'video.js/dist/types/player';

const GalleryVideoPlayers = (() => {
    let currentPlayer: Player | null = null; // To keep track of the currently playing player

    // Function to initialize players
    const initPlayers = () => {
        console.log('Initializing video players...');
        const videoElements = document.querySelectorAll<HTMLVideoElement>('.gallery-video');

        videoElements.forEach(videoElement => {
            const player = videojs(videoElement.id, {
                controls: true, // Show default controls
                autoplay: false,
                preload: 'auto'
            });

            const customPlayButton = document.querySelector<HTMLButtonElement>(`.custom-play-button[data-id="${videoElement.dataset.id}"]`);


            // Event listener for custom play button
            customPlayButton?.addEventListener('click', () => { 
                player.play(); // Play the selected video                
                customPlayButton.style.display = 'none'; // Hide the custom play button when video starts playing
            });

            // Show the custom play button when video ends
            player.on('ended', () => {
                if (customPlayButton) {
                    customPlayButton.style.display = 'block'; // Show the custom play button
                }
                if (currentPlayer === player) {
                    currentPlayer = null; // Clear the current player reference
                }
            });

            // Hide custom play button when the video starts playing
            player.on('play', () => {

                if (currentPlayer && currentPlayer !== player) {
                    currentPlayer.pause(); // Pause the current player
                }

                currentPlayer = player; // Update current player reference

                if (customPlayButton) {
                    customPlayButton.style.display = 'none'; // Hide the custom play button
                }
            });
        });
    };

    // Function to stop the currently playing video
    const stopPlaying = () => {
        
        if (currentPlayer) {
            currentPlayer.pause(); // Pause the currently playing video
            currentPlayer = null; // Reset current player reference
            console.log('Video stopped.');
        }
    };

    // Expose the initPlayers and stopPlaying functions
    return { initPlayers, stopPlaying };
})();

// Export the instance with both functions
export default GalleryVideoPlayers;
